/*
 * @Author: libo 
 * @Date: 2020-12-01 14:46:47 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-07-18 15:33:26
 */

<!-- 缴费记录页面 -->
<template>
<a-row :gutter="24" class="new-row">
  <a-col :md="collapsed? 0: 5" :sm="24" class="new-col">
    <a-card :bordered="false" class="new-tree-card">
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <div style="display: flex;margin-top: 10px;">
            <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
            <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
          </div>
          <!-- 树-->
          <a-col :md="24" :sm="24" class="new-tree-col">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <span style="user-select: none">
                  <a-tree
                    show-line
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
    </a-card>
  </a-col>
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
    <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
      @click="collapsed = !collapsed"
      class="area-collapsed"></a-icon>
  <a-card :bordered="false" class="new-table-card">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表编号')">
              <j-input :placeholder="$t('请输入表编号模糊查询')" v-model="queryParam.meterId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户编号')">
              <j-input :placeholder="$t('请输入用户编号模糊查询')" v-model="queryParam.meterUserId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户姓名')">
              <j-input :placeholder="$t('请输入用户姓名模糊查询')" v-model="queryParam.userName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户地址')">
              <j-input :placeholder="$t('请输入用户地址模糊查询')" v-model="queryParam.userAddr"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <!--
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="购买金额">
                <a-input placeholder="请输入购买金额" v-model="queryParam.userPayAccountNum"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="购买吨数">
                <a-input placeholder="请输入购买吨数" v-model="queryParam.payWaterNum"></a-input>
              </a-form-item>
            </a-col>
            -->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('缴费途径')">
                <a-select  v-model="queryParam.payWay" :placeholder="$t('请选择缴费途径')">
                  <a-select-option v-for="(item,value) in payWayObj" :value="value" :key="value">
                    {{ $t(item) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('交易流水号')">
                <a-input :placeholder="$t('请输入交易流水号')" v-model="queryParam.payOrderId"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('价格名称')">
                <a-select v-model="queryParam.userPriceName" :placeholder="$t('请选择价格名称')">
                  <a-select-option v-for="data in userPriceCode" :key="data.id" :value="data.wtName">
                    {{data.wtName}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表口径')">
                <a-select v-model="queryParam.meterCaliber" :placeholder="$t('请选择表口径')">
                  <a-select-option v-for="data in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                    DN{{data.mtCaliber}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('操作类型')">
                <a-select
                  mode="multiple"
                  style="width: 100%"
                  :placeholder="$t('请选择操作类型')"
                  :maxTagCount="2"
                  v-model="userAccountPayType"
                  @change="handleChange"
                >
                  <a-select-option v-for="(item,value) in payTypeObj" :value="value" :key="value">
                    {{ $t(item) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            
            <!--
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="用水价格">
                <a-input placeholder="请输入用水价格名字 用水性质" v-model="queryParam.userPriceName"></a-input>
              </a-form-item>
            </a-col>
            -->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('起止时间')">
                <a-range-picker
                  v-model="date"
                  format="YYYY-MM-DD"
                  :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                  @change="onDateRangeChange"
                  @ok="onOk"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('操作员')">
                <a-select v-model="queryParam.createBy" :placeholder="$t('请选择操作员')" allowClear>
                  <a-select-option v-for="data in userArray" :key="data.username" :value="data.username">
                    {{data.username}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls($t('缴费记录'))">{{ $t('导出') }}</a-button>
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <!-- 汇总显示 -->
    <a-descriptions :column="4">
      <a-descriptions-item :label="$t('记录条数')">
        <span v-if="loading">
          <a-spin size="small" />
        </span>
        <span v-else>
          {{summarizing.sumCount}}
        </span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('累计充值金额')">
        <span v-if="loading">
          <a-spin size="small" />
        </span>
        <span v-else>
          ¥{{towNumber(summarizing.sumPayNum)}}
        </span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('累计退水金额')">
        <span v-if="loading">
          <a-spin size="small" />
        </span>
        <span v-else>
          ¥{{towNumber(summarizing.sumBackNum)}}
        </span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('累计补水金额')">
        <span v-if="loading">
          <a-spin size="small" />
        </span>
        <span v-else>
          ¥{{towNumber(summarizing.sumMakeUpNum)}}
        </span>
      </a-descriptions-item>
    </a-descriptions>
    <!-- table区域-begin -->
    <div class="table-fixed">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
        <span style="float:right;">
          <a @click="loadData()"><a-icon type="sync" />{{ $t('刷新') }}</a>
          <a-popover :title="$t('自定义列')" trigger="click" placement="leftBottom">
            <template slot="content">
              <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                <a-row>
                  <template v-for="item in defColumns">
                    <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                      <a-col :span="12" :key="item.key"><a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox></a-col>
                    </template>
                  </template>
                </a-row>
              </a-checkbox-group>
            </template>
          </a-popover>
        </span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :components="drag(columns)"
        @change="handleTableChange">
        <div slot="filterDropdown">
          <a-card>
            <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
              <a-row>
                <template v-for="item in defColumns">
                  <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                    <a-col :span="12" :key="item.key">
                      <a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
                    </a-col>
                  </template>
                </template>
              </a-row>
            </a-checkbox-group>
          </a-card>
        </div>
        <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
        <template slot="userNowAccountNum" slot-scope="text, record">
          <a-tag style="font-size: 14px" :color="record.userNowAccountNum==null?'':record.userNowAccountNum<=0?'red':'green'">{{record.userNowAccountNum}}</a-tag>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <a-divider type="vertical" />
          <a @click="printPayDetail(record)">{{ $t('打印票据') }}</a>
        </span>
      </a-table>
    </div>
    <meter-user-pay-record-modal ref="modalForm" @ok="modalFormOk"></meter-user-pay-record-modal>
    <print-pay-note-modal ref="printPayNoteModal"></print-pay-note-modal>
  </a-card>
  </a-col>
</a-row>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import configService from '@/utils/service/config.service'
  import MeterUserPayRecordModal from './modules/MeterUserPayRecordModal'
  import { httpAction,getAction } from '@/api/manage'
  import { listSize } from '@/utils/util'
  import moment from 'moment'
  import {isUndefined,isNull,isUndefinedAndNull} from'@/utils/validate'
  import printPayNoteModal from '@/views/meterManagement/modules/printPayNoteModal'
  import Vue from 'vue'
  import {payWayObj,payTypeObj} from '@/utils/constants/commonConstant'
  import JInput from '@/components/jeecg/JInput'
  import TableDragResize  from '@/mixins/TableDragResize'

  export default {
    name: 'MeterUserPayRecordList',
    mixins:[JeecgListMixin, mixinDevice, AreaChoosetMixin,TableDragResize],
    components: {
      MeterUserPayRecordModal,
      printPayNoteModal,
      JInput
    },
    data () {
      return {
        description: 'mete_change_meter_record管理页面',
        collapsed: false,
        payWayObj,
        payTypeObj,
        //表头
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          user: "/sys/user/list",  //操作员列表
          list: "/jeecg-charge/meter/meterUserPayRecord/list",
          delete: "/jeecg-charge/meter/meteChangeMeterRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meteChangeMeterRecord/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUserPayRecord/exportXls",  //导出接口
          importExcelUrl: "jeecg-charge/meter/meteChangeMeterRecord/importExcel",
          doPayCancleTask:"/jeecg-charge/meter/meterUserPayRecord/doPayCancleTask",   //撤销
          doPayUncancleTask:"/jeecg-charge/meter/meterUserPayRecord/doPayUncancleTask", 
          sumResult:"/jeecg-charge/meter/meterUserPayRecord/sumResult",  //缴费记录汇总报表
          userPriceCode: "/jeecg-charge/meter/meterPriceinfo/list",  // 用水性质
          userCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
        },
        dictOptions:{},
        endOpen: false,
        date:[],
        summarizing:{},  //缴费记录汇总报表
        /*item:{
        id:'',
        userKeyId:'',
        },*/
        userArray:[],  //操作员
        dateType: 2,
        userAccountPayType: [],
        userPriceCode: [],  //用水性质
        userCaliberList:[],  // 表口径
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.queryUserPriceCode();
      this.queryUserCaliberList();
      this.queryUserList();
      this.loadData(1);
      this.initColumns();
    },
    computed: {
      importExcelUrl: function(){
        return `${configService.apiUrl}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          // {
          //   title:'用户表meteruserinfo里的主键id',
          //   align:"center",
          //   dataIndex: 'userKeyId'
          // },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'meterUserId',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('表口径'),
            align: "center",
            dataIndex: 'meterCaliber',
            customRender: (t, r, index) => {
              if(t){
                return 'DN' + t
              }
              return ''
            },
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('用户地址'),
            align:"center",
            dataIndex:'userAddr',
            width:200,
            ellipsis: true,
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },
          {
            title: this.$t('价格名称'),
            align:"center",
            dataIndex: 'userPriceName',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('购买金额(元)'),
            align:"center",
            dataIndex: 'userPayAccountNum',
            width:150,
            customRender: (t,r,index) => {
              if(!isUndefined(r.userAccountPayType)&&[2,4,6].includes(r.userAccountPayType)) {
                return '-'+t
              }
              return t
            }
          },
          {
            title: this.$t('购买量(吨)'),
            align:"center",
            dataIndex: 'payWaterNum',
            width:150,
            customRender: (t,r,index) => {
              if(isUndefinedAndNull(t)) {
                return '--'
              }
              if(!isUndefinedAndNull(r.userAccountPayType)&&[2,4,6].includes(r.userAccountPayType)) {
                return '-'+t
              }
              return t
            }
          },
          {
            title: this.$t('操作类型'),
            align:"center",
            dataIndex: 'userAccountPayType',
            width:100,
            customRender: (t,r,index) => {
              let data = payTypeObj
              if(!isUndefined(data[t])) {
                return this.$t(data[t])
              }
              return this.$t('未知')
            }
          },
          {
            title: this.$t('缴费途径'),
            align:"center",
            dataIndex: 'payWay',
            width:100,
            customRender: (t,r,index) => {
              let obj = payWayObj
              if(!isUndefined(obj[t])) {
                return this.$t(obj[t])
              }
              return this.$t('未知')
            }
          },
          {
            title: this.$t('交易流水号'),
            align:"center",
            dataIndex: 'payOrderId',
            width:200,
            ellipsis: true
          },
          {
            title: this.$t('剩余金额(元)'),
            align:"center",
            dataIndex: 'userNowAccountNum',
            scopedSlots: { customRender: 'userNowAccountNum' },
            width:150,
          },
          /*
          {
            title:'用水价格名字',
            align:"center",
            dataIndex: 'userPriceName'
          },
          {
            title:'水费单价',
            align:"center",
            dataIndex: 'userPriceTotal'
          },*/
          {
            title: this.$t('缴费时间'),
            align:"center",
            dataIndex: 'createTime',
            width:150,
            customRender: (t,r,index) => {
              // 撤销充值的记录只是修改记录的更新时间等信息，不增加记录，所以需要这样处理现实操作时间
              if(!isNull(r.paymentTime)&&r.paymentTime!="") {
                return r.paymentTime
              }
              return t
            }
          },
          {
            title: this.$t('操作员'),
            align:"center",
            dataIndex: 'createBy',
            width:150,
            customRender: (t,r,index) => {
              // 撤销充值的记录只是修改记录的更新时间等信息，不增加记录，所以需要这样处理现实操作时间
              if(!isNull(r.updateBy)&&r.updateBy!="") {
                return r.updateBy
              }
              return t
            }
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      queryUserCaliberList() {   //表口径请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.column = 'mtCaliber';
        params.order = 'asc';
        getAction(this.url.userCaliberList, params).then((res) => {
          if(res.success){
            this.userCaliberList = res.result.records;
          }
        }) 
      },
      queryUserPriceCode() {  //用水性质请求
          let params = {}
          params.pageNo = 1;
          params.pageSize = listSize;
          getAction(this.url.userPriceCode, params).then((res) => {
              if (res.success) {
                  this.userPriceCode = res.result.records;
                  console.log(this.userPriceCode);
              }
          })
      },
      loadListData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t('请设置url.list属性!'))
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      queryUserList() {   //操作员请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.user, params).then((res) => {
          if(res.success){
            this.userArray = res.result.records;
          }
        }) 
      },
      querysumResult() {   //缴费记录汇总报表
        let params = this.getQueryParams();//查询条件
        console.log(params)
        getAction(this.url.sumResult, params).then((res) => {
          if(res.success ){
            this.summarizing = res.result;
          }
        })
      },
      towNumber(val) {    //保留两位小数  
        if (!val) {
          return 0;
        }
        return val.toFixed(2);  
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      onOk(value) {
        console.log('onOk: ', value);
      },
      printPayDetail(record){
        // 打印票据
        record.orderId = record.payOrderId
        this.$refs.printPayNoteModal.edit(record)
      },
      handleChange(value) {
        this.queryParam.userAccountPayType = value +"";
      },
      loadData(arg) {
        this.querysumResult();
        this.loadListData(arg);
      },
      handleTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadListData();
      },
      searchReset() {
        this.queryParam = {}
        this.resetAareaData()
        this.date = []
        this.userAccountPayType = []
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>